// =============================================================================
// web/shims/react-native-fs.js — WEB shim for @dr.pogodin/react-native-fs.
//
// The only consumer is the E2E MEDIA path (services/e2e.ts), which treats ANY fs
// failure as "skip encryption / show placeholder" — never a crash. On web there
// is no native filesystem, so every op rejects/no-ops gracefully and e2e.ts falls
// back to its plaintext path. Native iOS resolves the real package untouched.
// =============================================================================
export const CachesDirectoryPath = '/tmp';
export const DocumentDirectoryPath = '/tmp';
export const TemporaryDirectoryPath = '/tmp';

export async function readFile() {
  throw new Error('filesystem not available on web');
}
export async function writeFile() {
  throw new Error('filesystem not available on web');
}
export function downloadFile() {
  return { promise: Promise.reject(new Error('filesystem not available on web')) };
}
export async function unlink() {
  // idempotent no-op
}
export async function exists() {
  return false;
}
export async function mkdir() {}

export default {
  CachesDirectoryPath,
  DocumentDirectoryPath,
  TemporaryDirectoryPath,
  readFile,
  writeFile,
  downloadFile,
  unlink,
  exists,
  mkdir,
};
